import { useMemo, HtmlHTMLAttributes } from 'react';
import classNames from 'classnames';
import useStyles from './TabIndicator.styles';

export interface ITabIndicatorProps extends HtmlHTMLAttributes<HTMLSpanElement> {
  /**
   * Controls side of active tab indicator for vertical layout
   * (will be rendered with "right: 0" by default)
   */
  left?: boolean;
  /** Controls tabs layout direction (horizontal by default) */
  vertical?: boolean;
}

export function TabIndicatorComponent({
  className,
  left = false,
  vertical = false,
  ...other
}: ITabIndicatorProps) {
  const classes = useStyles(useMemo(() => ({ left, vertical }), [left, vertical]));

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <span className={classNames(classes.indicator, className)} {...other} />;
}

export default TabIndicatorComponent;
